import React from 'react'
import {
  Table,
  Section,
  SectionHeader,
  SectionBody,
} from '@apexinternal/ui-components'
import { Box, BoxProps } from '@chakra-ui/react'
import { capitalize, uniqueId, isEmpty } from 'lodash'
import { AuthorizedTrader } from 'types'

export interface AuthorizedTradersTableProps extends BoxProps {
  authorizedTraders?: AuthorizedTrader[]
}

const columns = [
  {
    key: 'name',
    label: 'Name',
    recordField: 'name',
    isSortable: false,
  },
  {
    key: 'tradingAuthorityCode',
    label: 'Trading Auth',
    recordField: 'tradingAuthorityCode',
    isSortable: false,
    width: '25%',
    cellRenderer: ({ value }: { value: any }) => <Box>{capitalize(value)}</Box>,
  },
  {
    key: 'hasDiscretionaryAuthority',
    label: 'Discretionary Auth',
    recordField: 'hasDiscretionaryAuthority',
    isSortable: false,
    width: '25%',
    cellRenderer: ({ value }: { value: any }) => (
      <Box>{value ? 'Yes' : 'No'}</Box>
    ),
  },
  {
    key: 'discretionaryAuthorizationExpDate',
    label: 'Auth Expiration',
    recordField: 'discretionaryAuthorizationExpDate',
    isSortable: false,
    width: '25%',
  },
]

const AuthorizedTradersTable = ({
  authorizedTraders,
  ...rest
}: AuthorizedTradersTableProps) => {
  if (!authorizedTraders || isEmpty(authorizedTraders)) return null

  const data = authorizedTraders.map(authorizedTrader => ({
    ...authorizedTrader,
    key: uniqueId(),
  }))

  return (
    <Section {...rest}>
      <SectionHeader>Authorized Traders</SectionHeader>
      <SectionBody>
        <Table
          columns={columns}
          data={data}
          defaultSort={{
            field: 'name',
            ascending: true,
          }}
        />
      </SectionBody>
    </Section>
  )
}

export default AuthorizedTradersTable
